import LocationConfig from "./LocationConfig";

export default class LocationService {
	static getProvinces() {
		return new Promise(async (resolve, reject) => {
			try {
				let endpoint = LocationConfig.endpointGetProvinces;
				let response = await LocationConfig.APIConnector.get(endpoint);
				resolve(response);
			} catch (error) {
				reject(error);
			}
		});
	}

	static getCitiesofProvice(idProvince) {
		return new Promise(async (resolve, reject) => {
			try {
				let endpoint = LocationConfig.endpointGetCitiesOfProvince + idProvince;
				let response = await LocationConfig.APIConnector.get(endpoint);
				resolve(response);
			} catch (error) {
				reject(error);
			}
		});
	}
}



// WEBPACK FOOTER //
// ./src/provider/Location/LocationService.js